import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import TextInput from '../../component/dccore-form/textInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/simple-form/checkbox.vue'
import Ckeditor from '../../component/dccore-form/ckeditor.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'
import TranslationInput from '../../component/dccore-form/translationInput.vue'
import { material } from '../../const/common'

if ($('#material_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#material_form',
    components: {
      TextInput,
      RingLoader,
      Singleselect,
      Multiselect,
      NumberInput,
      Checkbox,
      Ckeditor,
      multimedia,
      TranslationInput
    },
    mixins: [mixins],
    data: {
      form: {
        entity: {
          ingredient:{},
          type: material.TYPE_PORTION,
          unit: material.UNIT_MASS,
          notStoredInWarehouse: false,
          notIncludedInWarehouseShifts: false,
          height : 0,
          width: 0,
          length: 0,
          volume: 0,
          isRotatable: false,
          composition: null,
          compositionTranslation: {},
          valueTranslation: {},
        },
        options: {
          errors: { ingredients:{} },
          stickers: [],
          allergens: [],
          units: [],
          types: [],
          portionCategories: [],
        }
      },
      selectedSticker : {},
      brands: [],
      packageTypes: [],
      loading: 0,
      entityId: null,
      ingredientsNames: {},
      rowsIngredients: 0,
      amountIngredients: 0,
      disabled: true,
      multimedia: [],
    },
    computed: {
      packageVolume: function () {
        return Math.round((this.form.entity.height * this.form.entity.width * this.form.entity.length) * 100) / 100
      },
      compositionAllowed() {
        return this.form.entity.type === material.TYPE_PORTION && this.isFinishedProductsCategory()
      },
      isRotateAvailable() {
        return this.form.entity.type === material.TYPE_PACKAGE
      },
    },
    watch: {
      'form.entity.type'(val) {
        if (val === material.TYPE_PORTION) {
          this.form.entity.unit = material.UNIT_MASS
          this.disabled = true
        } else if (this.isPackageType()) {
          this.form.entity.unit = material.UNIT_PIECE
          this.disabled = true
        } else {
          this.form.entity.unit = material.UNIT_PIECE
          this.disabled = false
        }
      },
    },
    mounted() {
      this.getAllergens()
      this.getBrands()
      this.getStickers()
      this.getUnits()
      this.getTypes()
      this.getPackageTypes()
      this.getPortionCategories()
      this.getIngredientsNames()

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getMaterial()
      } else {
        this.fillStocks()
      }
    },
    methods: {
      isPackageType() {
        return this.packageTypes.includes(this.form.entity.type)
      },
      getPackageTypes() {
        let url = Routing.generate('api_get_package_types')
        this.loading++
        Vue.http.get(url).then(response => {
          this.packageTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      createMaterial(redirect) {
        $('.button-save').button('loading')
        let url = Routing.generate('api_post_material')

        this.form.entity.volume = Math.round((
          this.form.entity.height * this.form.entity.width * this.form.entity.length) * 100
        ) / 100
        let data = {
          data: this.form.entity,
          selectedSticker: this.selectedSticker,
          multimedia: this.multimedia,
        }

        Vue.http.post(url, data).then(() => {
          this.errors = { ingredient: {} }
          if (redirect) {
            $(location).attr('href', Routing.generate('material_grid'))
          } else {
            toastr.success(Translator.trans('material.create.created'))
          }
          $('.button-save').button('reset')
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })

      },
      updateMaterial(redirect) {
        $('.button-save').button('loading')
        let url = Routing.generate('api_patch_material', { id: this.entityId })
        this.form.entity.volume = Math.round((
          this.form.entity.height * this.form.entity.width * this.form.entity.length) * 100
        ) / 100
        let data = {
          data: this.form.entity,
          selectedSticker: this.selectedSticker,
          multimedia: this.multimedia,
        }

        Vue.http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('material_grid'))
          } else {
            toastr.success(Translator.trans('material.update.updated'))
            this.form.options.errors = { ingredients:{} }
          }
          $('.button-save').button('reset')
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })

      },
      getMaterial() {
        let url = Routing.generate('api_get_material', { id: this.entityId,
          context: 'edit' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.entity = response.data

          if (this.form.entity.packageStickers) {
            this.transformSelectedStickers(this.form.entity.packageStickers)
          }

          if (this.form.entity.multimedia) {
            this.multimedia = this.form.entity.multimedia.collection

            delete this.form.entity.multimedia
          }

          if (!('ingredient' in this.form.entity)) {
            this.form.entity.ingredient = {}
          }
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })

      },
      getAllergens() {
        let url = Routing.generate('api_get_tags_allergen')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.allergens = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getUnits() {
        let url = Routing.generate('api_get_materials_units')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.units = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getTypes() {
        let url = Routing.generate('api_get_materials_types')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.types = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getPortionCategories() {
        let url = Routing.generate('api_get_tags', { 'type': 'portion_category',
          context: 'material_update' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.portionCategories = response.data
          this.loading--

        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.loading--
          this.brands = response.data
          for (let i = 0; i < this.brands.length; i++) {
            this.selectedSticker[this.brands[i]] = null
          }
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getStickers() {
        let url = Routing.generate('api_get_stickers')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.stickers = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getIngredientsNames() {
        this.loading++
        let url = Routing.generate('api_get_ingredients')

        Vue.http.get(url).then(response => {
          this.ingredientsNames = response.data
          this.rowsIngredients = Math.floor(this.ingredientsNames.length / 3)
          this.amountIngredients = this.ingredientsNames.length
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      transformSelectedStickers(stickers) {
        for (let i = 0; i < stickers.length; i++) {
          this.selectedSticker[stickers[i].brandId] = stickers[i].sticker
        }
      },
      translateType(name) {
        return Translator.trans(`material.entity.types.${name}`)
      },
      translatePortionCategory(name) {
        return Translator.trans(`material.entity.portions_categories.${name}`)
      },
      validateInput(event) {
        event.target.prevValue = event.target.value
      },
      isNumber(event) {
        if (event.keyCode === 8 || event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39) {
          return
        }
        let value = event.target.value
        if (/^\d+[,.]?\d{0,2}$/.test(value) === false) {
          event.target.value = event.target.prevValue
          if (isNaN(event.target.value)) {
            event.target.value = 0
            value = event.target.value
          } else {
            value = Math.round(event.target.value * 100) / 100
          }
        }
        this.form.entity[event.target.id] = value
      },
      handleCompositionChange(e) {
        if (this.form.entity.type === material.TYPE_PORTION && e.systemValue === 'PORTION_CATEGORY_FINISHED_PRODUCTS') {
          return
        }

        this.form.entity.composition = null
      },
      isFinishedProductsCategory() {
        let category = this.form.options.portionCategories.find(category => category.id === this.form.entity.portionCategory)
        if (category) {
          return category.systemValue === 'PORTION_CATEGORY_FINISHED_PRODUCTS'
        }

        return false
      },
      fillStocks() {
        this.loading++
        let url = Routing.generate('api_get_warehouse_supply_warehouses')

        Vue.http.get(url).then(response => {
          let warehouses = response.data

          this.form.entity.warehouseStocks = []
          for (let warehouse in warehouses) {
            this.form.entity.warehouseStocks.push({
              warehouse: warehouses[warehouse].id,
              warehouseName: warehouses[warehouse].name,
              minState: null,
              maxState: null,
              notIncludedInPurchaseOrders: null,
              notIncludedInWarehouseShifts: null
            })
          }

          this.loading--
        })
      }
    }
  })
}
